/**
 * @consumes CellReader
 */
export var Cell = _props => null;
Cell.displayName = 'Cell';